// app/components/SuvatAreaNoSSR.tsx
"use client";

import LazyHydrate from "@/app/components/LazyHydrate";
import Spinner from "@/app/components/Spinner";

/**
 * Area-under-graph widget (~140 kB after the Plotly-lite split).
 * LazyHydrate keeps that JS out of the critical path until needed.
 */
export default function SuvatArea() {
  return (
    <LazyHydrate
      loader={() => import("@/app/components/SuvatAreaPlotly")}
      rootMargin="600px" // start fetch one screenful ahead
      threshold={0} // hydrate as soon as any pixel is visible
      fallback={<Spinner />}
    />
  );
}
